/**
 * The participant's dossier in the portal — the checks the page can make
 * before asking the server, so a 300 MB video is refused in a second instead
 * of after the request. The server checks everything again; these only spare
 * the wait.
 */

export const MAX_FILE_BYTES = 50 * 1024 * 1024;

export const ALLOWED_EXTENSIONS = [
  "pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx", "odt", "odp",
  "png", "jpg", "jpeg", "webp", "mp4", "mp3", "zip",
];

export const ACCEPT_ATTR = ALLOWED_EXTENSIONS.map((e) => `.${e}`).join(",");

const DANGEROUS = ["html", "htm", "svg", "js", "exe"];

export const ALLOWED_LABEL = "PDF, Word, PowerPoint, Excel, OpenDocument, imagini (PNG, JPG, WEBP), MP4, MP3 și ZIP";

export function extensionOf(name) {
  const s = String(name || "");
  const i = s.lastIndexOf(".");
  return i > 0 ? s.slice(i + 1).toLowerCase() : "";
}

/** Null when the file may go up, else the sentence the person reads. */
export function fileProblem(file, { usedBytes = 0, limitBytes = Infinity } = {}) {
  if (!file) return "Alege un fișier.";
  const ext = extensionOf(file.name);
  if (DANGEROUS.includes(ext)) {
    return `Fișierele .${ext} nu se pot încărca: s-ar putea deschide ca pagini sau programe. Salvează-l ca PDF.`;
  }
  if (!ALLOWED_EXTENSIONS.includes(ext)) {
    return `${ext ? `Tipul .${ext}` : "Un fișier fără extensie"} nu se poate încărca. Merg: ${ALLOWED_LABEL}.`;
  }
  if (!file.size) return "Fișierul e gol.";
  if (file.size > MAX_FILE_BYTES) {
    return `${file.name} are ${formatBytes(file.size)}; limita e 50 MB pe fișier.`;
  }
  if (usedBytes + file.size > limitBytes) {
    return `Nu mai e loc pentru ${file.name}: mai ai ${formatBytes(Math.max(0, limitBytes - usedBytes))}.`;
  }
  return null;
}

/** "740 KB", "12,4 MB" — Romanian decimal comma, no false precision. */
export function formatBytes(n) {
  const bytes = Math.max(0, Number(n) || 0);
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  const mb = bytes / (1024 * 1024);
  const text = mb >= 100 ? String(Math.round(mb)) : mb.toFixed(1).replace(/\.0$/, "");
  return `${text.replace(".", ",")} MB`;
}

/** "12,4 MB din 500 MB", and how full the bar is. */
export function roomLine(usedBytes, limitBytes) {
  const pct = limitBytes > 0 ? Math.min(100, Math.round((usedBytes / limitBytes) * 100)) : 0;
  return { text: `${formatBytes(usedBytes)} din ${formatBytes(limitBytes)}`, pct };
}

export function uploadedOn(iso) {
  if (!iso) return "";
  return new Intl.DateTimeFormat("ro-RO", {
    timeZone: "Europe/Bucharest", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit",
  }).format(new Date(iso));
}
